export const WindowTariffs = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.7093 2.28003C4.06482 2.28003 3.44674 2.53605 2.99103 2.99176C2.53531 3.44747 2.2793 4.06555 2.2793 4.71003H21.7193C21.7193 4.06555 21.4633 3.44747 21.0076 2.99176C20.5519 2.53605 19.9338 2.28003 19.2893 2.28003H4.7093ZM2.2793 19.29V5.92503H21.7193V19.29C21.7193 19.9345 21.4633 20.5526 21.0076 21.0083C20.5519 21.464 19.9338 21.72 19.2893 21.72H4.7093C4.06482 21.72 3.44674 21.464 2.99103 21.0083C2.53531 20.5526 2.2793 19.9345 2.2793 19.29ZM16.8593 9.57003C16.8593 9.89227 16.9873 10.2013 17.2152 10.4292C17.443 10.657 17.7521 10.785 18.0743 10.785C18.3965 10.785 18.7056 10.657 18.9334 10.4292C19.1613 10.2013 19.2893 9.89227 19.2893 9.57003C19.2893 9.24779 19.1613 8.93875 18.9334 8.71089C18.7056 8.48304 18.3965 8.35503 18.0743 8.35503C17.7521 8.35503 17.443 8.48304 17.2152 8.71089C16.9873 8.93875 16.8593 9.24779 16.8593 9.57003Z"
      fill="#0AAAE6"
    />
  </svg>
);
